import { Step } from "react-joyride";

/**
 * Guided tour steps for the Final Evaluation step (solo and panel member views).
 *
 * Each step targets a `data-testid` attribute rendered in the step.
 * If a target isn't present, Joyride will auto-skip it.
 */
export const finalEvaluationSteps: Step[] = [
	{
		target: '[data-testid="final-instructions-info-box"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Final Scoring</h3>
				<p>
					In this step you re-score each supplier taking into account any
					clarification responses and revised documents received since your
					initial evaluation.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="supplier-response-table"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Supplier Scores</h3>
				<p>
					Click on a supplier to open the final scoring modal. Your initial
					scores are pre-filled — update any that need to change based on new
					information.
				</p>
				<p className="mt-2 text-gray-500">
					Each supplier must be scored before you can submit.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="final-submit-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Submit Final Scores</h3>
				<p>
					Once all suppliers have been scored, click here to submit your final
					evaluation. Submitted scores are permanent and cannot be modified.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
];

/**
 * Guided tour steps for the Final Evaluation step (Panel Lead view).
 */
export const finalEvaluationLeadSteps: Step[] = [
	{
		target: '[data-testid="tab-my-final-scores"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">My Final Scores</h3>
				<p>
					Complete your own final scores here. As RFx Lead, you score alongside
					panel members before reviewing the overall panel progress.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="tab-panel-progress"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Panel Members</h3>
				<p>
					Switch to this tab to monitor panel member progress. All members must
					submit their final scores before you can proceed to the panel meeting.
				</p>
				<p className="mt-2 text-gray-500">
					You can revoke access for members who won&apos;t be submitting.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
];
